(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/article/views/index.js') >= 0) return;  svs.modules.push('/widgets/article/views/index.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.widget=_svs.widget||{};
_svs.widget.article=_svs.widget.article||{};
_svs.widget.article.templates=_svs.widget.article.templates||{};
svs.widget.article.templates.index = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "    <div class=\"widget-default\">\n"
    + ((stack1 = container.invokePartial(partials["components-content-simple_article-simple_article"],depth0,{"name":"components-content-simple_article-simple_article","data":data,"indent":"        ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    </div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["with"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.currentWidget : depth0),{"name":"with","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
Handlebars.partials['widget-article-index'] = svs.widget.article.templates.index;
})(svs, Handlebars);

 })(window);